"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = browserStorage;
// Storage type is one of: 'local'/'session'
function browserStorage(storageType) {
  try {
    switch (storageType) {
      case 'local':
        return window.localStorage;
      case 'session':
        return window.sessionStorage;
      default:
        return null;
    }
  } catch (e) {
    return null;
  }
}